/**
 * @description: 客遗酒水回收入库审批设置
 * @author: hwx
 * @update: lyr(copy from 退款退货设置)
 */
<template>
	<div class="guest-leave-store-apply-wrap">
		<div class="rcw-list" v-show="showList">
			<h1>客遗酒水回收入库审批设置</h1>
			<!-- <div class="row row-margin">
				<button type="button" class="btn btn-flat btn-middle btn-orange" @click="addRcw">新增客遗酒水回收入库审批</button>
			</div> -->
			<div class="row">
				<label class="list-label-2">门店:</label>
				<div class="col-md-2 ct-col">
					<select class="form-control" ref="rcw_shop"></select>
				</div>
				<button type="button" class="btn btn-flat btn-small btn-orange pull-right" @click="queryList">查询</button>
				<button type="button" class="btn btn-flat btn-big btn-orange pull-right" @click="addRcw" style="margin-right:10px;">新增客遗酒水回收入库审批</button>
			</div>
			<div class="table-responsive">
				<table class="table table-bordered table-hover" data-pagination="true" ref="rcw_list"></table>
			</div>
		</div>
		<div class="rcw-edit" v-show="!showList">
			<div class="page-tit">{{edit_tit}}</div>
			<div class="row">
				<label class="ctr-label-left">规则名称:</label>
				<div class="col-md-5">
					<input class="form-control" placeholder="请输入规则名称" v-model="edit_name">
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">门店:</label>
				<div class="col-md-5 ct-col">
					<select class="form-control" ref="edit_shop"></select>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">包厢区域:</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" placeholder="请选择包厢区域" v-model="edit_area" ref="edit_area" readonly @click="openEditArea($event)">
					<span class="selection-clear" @click="clearInput('edit_area')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">包厢类型:</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" placeholder="请选择包厢类型" v-model="edit_type" ref="edit_type" readonly @click="openEditType($event)">
					<span class="selection-clear" @click="clearInput('edit_type')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row edit-usedate">
				<label class="ctr-label-left">使用日期:</label>
				<div class="col-md-5">
					<div ref="use_date_wrapper">
						<input class="form-control input-readonly" v-model="edit_usedate" placeholder="请选择使用日期" readonly>
					</div>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">使用时间:</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" v-model="edit_usetime" ref="edit_usetime" placeholder="请选择使用时间" readonly @click="openUsetime()">
					<span class="selection-clear" @click="clearInput('edit_usetime')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<label class="ctr-label-left">审批人:</label>
				<div class="col-md-5">
					<input class="form-control input-readonly" placeholder="请选择审批人" v-model="edit_admin" ref="edit_admin" readonly @click="openEditAdmin($event)">
					<span class="selection-clear" @click="clearInput('edit_admin')">×</span>
					<span class="span-arrow"><b></b></span>
				</div>
			</div>
			<div class="row">
				<button type="button" class="btn btn-flat btn-middle btn-border-gray" @click="backList">返回</button>
				<button type="button" class="btn btn-flat btn-middle btn-orange sub-margin" @click="editSave">保存</button>
			</div>
		</div>
		<!-- 包厢区域 -->
		<div class="ele-hide" ref="rcw_area_alert">
			<div class="multi-select">
				<div class="clearfix">
					<input type='checkbox' v-model='area_all' @click='areaAllCheck'>
					<span>全选</span>
				</div>
				<ul class="clearfix">
					<li v-for="item in area_arr">
						<input type="checkbox" v-model='area_item' :value="item.id">
						<span>{{item.name}}</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- 包厢类型 -->
		<div class="ele-hide" ref="rcw_type_alert">
			<div class="multi-select">
				<div class="clearfix">
					<input type='checkbox' v-model='type_all' @click='typeAllCheck'>
					<span>全选</span>
				</div>
				<ul class="clearfix">
					<li v-for="item in type_arr">
						<input type="checkbox" v-model='type_item' :value="item.id">
						<span>{{item.name}}</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- 使用时间 -->
		<div class="use-time-wrap" ref="rcw_usetime_alert">
			<div>
				<input type="checkbox" v-model="rcw_usetime_allday" value="1">
				<label>全天</label>
			</div>
			<h2>开始时间：</h2>
			<select ref="starthour"></select>
			<label class="colon">:</label>
			<select ref="startseconds"></select>
			<h2>结束时间：</h2>
			<select ref="stophour"></select>
			<label class="colon">:</label>
			<select ref="stopseconds"></select>
		</div>
		<!-- 审批人 -->
		<div class="ele-hide" ref="rcw_admin_alert">
			<div class="multi-select">
				<div class="clearfix">
					<input type='checkbox' v-model='admin_all' @click='adminAllCheck'>
					<span>全选</span>
				</div>
				<ul class="clearfix">
					<li v-for="item in admin_arr">
						<input type="checkbox" v-model='admin_item' :value="item.id">
						<span>{{item.name}}</span>
					</li>
				</ul>
			</div>
		</div>
		<!-- 每天 -->
		<!-- <div class="edit-usedate-everyday" v-show="false">
			<input type="checkbox" />
			<label>每天</label>
		</div> -->
	</div>
</template>

<script>
	import Vue from 'vue';
	export default {
		name: 'guest_leave_store_apply_set',
		data() {
			return {
				showList: true,
				modify: '1',
				rcw_list_total: '',

				edit_id: '',
				edit_tit: '',
				edit_name: '',
				edit_area: '',
				area_all: false,
				c_area_all: false,
				area_item: [],
				area_arr: [],
				edit_type: '',
				type_all: false,
				c_type_all: false,
				type_item: [],
				type_arr: [],
				edit_usedate: '',
				edit_usedate_start: '',
				edit_usedate_end: '',
				edit_usedate_everyday: '-1',
				edit_usetime: '',
				edit_usetime_start: '',
				edit_usetime_end: '',
				edit_usetime_allday: '-1',
				rcw_usetime_allday: '',
				edit_admin: '',
				admin_all: false,
				c_admin_all: false,
				admin_item: [],
				admin_arr: [],
			}
		},
		watch: {
			area_item: {
				handler: function(val, oldval) {
					if(this.area_item.length >= this.area_arr.length) {
						this.area_all = true;
						this.c_area_all = true;
					} else {
						this.area_all = false;
						this.c_area_all = false;
					}
				},
				deep: true
			},

			type_item: {
				handler: function(val, oldval) {
					if(this.type_item.length >= this.type_arr.length) {
						this.type_all = true;
						this.c_type_all = true;
					} else {
						this.type_all = false;
						this.c_type_all = false;
					}
				},
				deep: true
			},

			rcw_usetime_allday: {
				handler: function(val, oldVal) {
					if(val == '1') {
						$(this.$refs.starthour).attr('disabled', true);
						$(this.$refs.startseconds).attr('disabled', true);
						$(this.$refs.stophour).attr('disabled', true);
						$(this.$refs.stopseconds).attr('disabled', true);
					} else {
						$(this.$refs.starthour).attr('disabled', false);
						$(this.$refs.startseconds).attr('disabled', false);
						$(this.$refs.stophour).attr('disabled', false);
						$(this.$refs.stopseconds).attr('disabled', false);
					}
				},
				deep: true
			},

			admin_item: {
				handler: function(val, oldval) {
					if(this.admin_item.length >= this.admin_arr.length) {
						this.admin_all = true;
						this.c_admin_all = true;
					} else {
						this.admin_all = false;
						this.c_admin_all = false;
					}
				},
				deep: true
			},
		},
		mounted: function() {
			this.getShopData();
			this.initTable();

			this.initDate();
			this.initTime();
		},
		methods: {
			// 门店
			getShopData: function() {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getShopListByPurview",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							let arr = [];
							$.each(data.response.result, function(k, v) {
								arr.push({ id: v.id, text: v.name });
							});
							$(_this.$refs.rcw_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							});

							arr.shift();
							$(_this.$refs.edit_shop).select2({
								data: arr,
								minimumResultsForSearch: -1,
								language: "zh-CN",
								width: '100%'
							}).on("select2:select", function(e) {
								_this.getBoxArea($(_this.$refs.edit_shop).val());
								_this.edit_area = '';
								_this.area_item = [];
								_this.getBoxType($(_this.$refs.edit_shop).val());
								_this.edit_type = '';
								_this.type_item = [];
								new Promise(resolve => {
									_this.getAdmin(resolve)
								})
								_this.edit_admin = '';
								_this.admin_item = [];
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('网络错误');
					}
				});
			},
			// 包厢区域
			getBoxArea: function(shop_id) {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Shop/getRoomArea",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.area_arr = data['response']['result'];
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('出错啦');
					}
				});
			},
			// 包厢类型
			getBoxType: function(shop_id) {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "PublicData/api_getRoomType",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.type_arr = data['response']['result']['data'];
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('出错啦');
					}
				});
			},
			// 使用日期
			initDate: function() {
				let _this = this;
				$(_this.$refs.use_date_wrapper).daterangepicker({
					parentEl: '.edit-usedate',
					// drops: 'up',
					buttonClasses: ['btn btn-default'],
					applyClass: 'btn-small btn-orange',
					cancelClass: 'btn-small btn-gray',
				}, function(start, end, label) {
					_this.edit_usedate_start = start.format('YYYY-MM-DD');
					_this.edit_usedate_end = end.format('YYYY-MM-DD');
					if($(".edit-usedate-everyday input").val() == "1") {
						_this.edit_usedate = '每天';
						_this.edit_usedate_everyday = '1';
						return;
					} else {
						_this.edit_usedate = _this.edit_usedate_start + ' ~ ' + _this.edit_usedate_end;
						_this.edit_usedate_everyday = '-1';
					}
				});

				$(".edit-usedate .daterangepicker:last").find(".ranges").prepend(
					'<div class="edit-usedate-everyday">' +
						'<input type="checkbox" />' +
						'<label>每天</label>' +
					'</div>'
				);

				$(".edit-usedate-everyday input").click(function() {
					if($(this).val() == "1") {
						$(this).prop("checked", false);
						$(this).val('');
					} else {
						$(this).prop("checked", true);
						$(this).val('1');
					}
				});
			},
			// 使用时间
			initTime: function() {
				let _this = this;

				let seconds = [];
				for(let i = 0; i < 60; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					seconds[i] = item;
				};
				let hour = [];
				for(let i = 0; i < 24; i++) {
					let item = {};
					item.id = (i < 10) ? '0' + i : i;
					item.text = (i < 10) ? '0' + i : i;
					hour[i] = item;
				}
				$(_this.$refs.starthour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stophour).select2({
					data: hour,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.startseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				});
				$(_this.$refs.stopseconds).select2({
					data: seconds,
					language: "zh-CN",
					width: 'auto'
				})
			},
			openUsetime: function() {
				let _this = this;
				$(_this.$refs.starthour).val(_this.edit_usetime_start.split(':')[0]).trigger('change');
				$(_this.$refs.startseconds).val(_this.edit_usetime_start.split(':')[1]).trigger('change');
				$(_this.$refs.stophour).val(_this.edit_usetime_end.split(':')[0]).trigger('change');
				$(_this.$refs.stopseconds).val(_this.edit_usetime_end.split(':')[1]).trigger('change');
				layer.confirm('', {
					type: 1,
					skin: 'public-alert-skin',
					btn: ['确定', '取消'], // 按钮
					title: '使用时间',
					area: ['450px', ''], // 宽高
					content: $(_this.$refs.rcw_usetime_alert)
				}, function() {
					let starthour = $(_this.$refs.starthour).select2("val");
					let startseconds = $(_this.$refs.startseconds).select2("val");
					let stophour = $(_this.$refs.stophour).select2("val");
					let stopseconds = $(_this.$refs.stopseconds).select2("val");
					_this.edit_usetime_start = starthour + ":" + startseconds;
					_this.edit_usetime_end = stophour + ":" + stopseconds;
					if(_this.rcw_usetime_allday == '1') {
						_this.edit_usetime = '全天';
						_this.edit_usetime_allday = '1';
					} else {
						if(_this.edit_usetime_start == '00:00' && _this.edit_usetime_end == '00:00') {
							_this.edit_usetime = '全天';
							_this.edit_usetime_allday = '1';
						} else {
							_this.edit_usetime = _this.edit_usetime_start + " ~ " + _this.edit_usetime_end;
							_this.edit_usetime_allday = '-1';
						}
					}
					layer.closeAll();
				});
			},
			getAdmin(resolve) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"shop_id": $(_this.$refs.edit_shop).val()
						}
					},
					"comment": ""
				};
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "User/getList",
					async: false,
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							_this.admin_arr = data['response']['result']['user_info'];
							resolve()
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('出错啦');
					}
				});
			},

			// 初始化列表
			initTable: function() {
				let _this = this;
				$(_this.$refs.rcw_list).bootstrapTable('destroy');
				$(_this.$refs.rcw_list).bootstrapTable({
					pageNumber: 1,
					pageSize: 15,
					pageList: [],
					pagination: true,
					ajax: function(params) {
						_this.getRcwList(params);
					},
					sidePagination: "server",
					columns: [{
						field: "shop_name",
						title: "门店",
						width: "10%",
						valign: 'middle'
					}, {
						field: "name",
						title: "规则名称",
						width: "10%",
						valign: 'middle'
					}, {
						field: "room_area_name",
						title: "包厢区域",
						width: "10%",
						valign: 'middle'
					}, {
						field: "room_type_name",
						title: "包厢类型",
						width: "10%",
						valign: 'middle'
					}, {
						field: "start_date",
						title: "使用日期",
						width: "10%",
						valign: 'middle',
						formatter: function(value, row, index) {
							if(row.use_every_day == '1') {
								return '每天';
							} else {
								return value + ' ~ ' + row.end_date;
							}
						}
					}, {
						field: "start_time",
						title: "使用时间",
						width: "10%",
						valign: 'middle',
						formatter: function(value, row, index) {
							if(row.use_all_day == '1') {
								return '全天';
							} else {
								return value + ' ~ ' + row.end_time;
							}
						}
					}, {
						field: "apply_admin_name",
						title: "审批人",
						width: "10%",
						valign: 'middle'
					}, {
						title: "操作",
						width: "15%",
						valign: 'middle',
						events: {
							'click .edit': function(e, value, row, index) {
								_this.modify = 2;
								_this.edit_id = row.id;
								_this.edit_tit = '修改退款退货审批';
								_this.edit_name = row.name;
								$(_this.$refs.edit_shop).val(row.shop_id).trigger('change');
								$(_this.$refs.edit_shop).prop('disabled', true);
								_this.getBoxArea($(_this.$refs.edit_shop).val());
								_this.edit_area = row.room_area_name;
								_this.area_item = row.room_area;
								_this.getBoxType($(_this.$refs.edit_shop).val());
								_this.edit_type = row.room_type_name;
								_this.type_item = row.room_type;
								if(row.use_every_day == '1') {
									_this.edit_usedate_start = '';
									_this.edit_usedate_end = '';
									_this.edit_usedate = '每天';
									_this.edit_usedate_everyday = row.use_every_day;
									$(".edit-usedate-everyday input").val("1");
									$(".edit-usedate-everyday input").prop("checked", true);
								} else {
									_this.edit_usedate_start = row.start_date;
									_this.edit_usedate_end = row.end_date;
									_this.edit_usedate = row.start_date + ' ~ ' + row.end_date;
									_this.edit_usedate_everyday = row.use_every_day;
									$(".edit-usedate-everyday input").val("");
									$(".edit-usedate-everyday input").prop("checked", false);
								}
								if(row.use_all_day == '1') {
									_this.edit_usetime_start = '00:00';
									_this.edit_usetime_end = '00:00';
									_this.edit_usetime = '全天';
									_this.edit_usetime_everyday = row.use_all_day;
									_this.rcw_usetime_allday = '1';
								} else {
									_this.edit_usetime_start = row.start_time;
									_this.edit_usetime_end = row.end_time;
									_this.edit_usetime = row.start_time + ' ~ ' + row.end_time;
									_this.edit_usetime_allday = row.use_every_day;
									_this.rcw_usetime_allday = '';
								}
								new Promise(resolve => {
									_this.getAdmin(resolve)
								})
								.then(() => {
									_this.edit_admin = row.apply_admin_name;
									_this.admin_item = row.apply_admin_ids;
								})
								_this.showList = false;
							},
							'click .del': function(e, value, row, index) {
								layer.confirm('删除后不可恢复，确定删除吗？', {
									btn: ['确定', '取消']
								}, function() {
									_this.delRcw(row.id, row.shop_id);
								});
							}
						},
						formatter: function(value, row, index) {
							return '<span class="text-blue edit">修改</span>&nbsp;&nbsp;&nbsp;<span class="text-blue del">删除</span>'
						}
					}]
				});
			},
			getRcwList: function(params) {
				let _this = this,
					pageNumber = 1;
				if(params != "" && params.data.offset != 0) {
					pageNumber = parseInt(params.data.offset / params.data.limit) + 1;
				}
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"page": pageNumber,
							"page_size": params.data.limit,
							"shop_id": $(_this.$refs.rcw_shop).val(),
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/getGuestLeaveStoreApplyRuleList",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							if(pageNumber == '1') {
								_this.rcw_list_total = data.response.result.count;
							}
							params.success({
								total: _this.rcw_list_total,
								rows: data.response.result.data
							});
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
			// 查询
			queryList: function() {
				this.initTable();
			},
			// 打开新增
			addRcw() {
				let _this = this;
				_this.modify = '1';
				_this.edit_tit = '新增退款退货审批';
				_this.edit_name = '';
				$(_this.$refs.edit_shop).val('').trigger('change');
				$(_this.$refs.edit_shop).prop('disabled', false);
				_this.getBoxArea($(_this.$refs.edit_shop).val());
				_this.edit_area = '';
				_this.area_item = [];
				_this.getBoxType($(_this.$refs.edit_shop).val());
				_this.edit_type = '';
				_this.type_item = [];
				_this.edit_usedate_start = '';
				_this.edit_usedate_end = '';
				_this.edit_usedate = '每天';
				_this.edit_usedate_everyday = '1';
				$(".edit-usedate-everyday input").val("1");
				$(".edit-usedate-everyday input").prop("checked", true);
				_this.edit_usetime_start = '00:00';
				_this.edit_usetime_end = '00:00';
				_this.edit_usetime = '全天';
				_this.edit_usetime_allday = '1';
				_this.rcw_usetime_allday = '1'
				new Promise(resolve => {
					_this.getAdmin(resolve)
				})
				_this.edit_admin = '';
				_this.admin_item = [];
				_this.showList = false;
			},
			// 包厢区域
			openEditArea: function(e) {
				let _this = this;
				let c_area_item = _this.area_item;

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['包厢区域', true],
					area: ['660px', ''], // 宽高
					content: $(_this.$refs.rcw_area_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_area != "") {
							_this.area_item = c_area_item;
							return;
						}
						_this.area_item = [];
					}
				}, function() {
					let texts = [];
					_this.area_arr.forEach(function(item) {
						_this.area_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_area = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_area != "") {
						_this.area_item = c_area_item;
						return;
					}
					_this.area_item = [];
				});
			},
			// 全选
			areaAllCheck: function() {
				let _this = this;
				_this.area_all = _this.c_area_all;
				if(!_this.area_all) { // 实现全选
					_this.area_item = [];
					_this.area_arr.forEach(function(item) {
						_this.area_item.push(item.id);
					});
				} else { // 实现反选
					_this.area_item = [];
				}
			},
			// 包厢类型
			openEditType: function(e) {
				let _this = this;
				let c_type_item = _this.type_item;

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['包厢类型', true],
					area: ['660px', ''], // 宽高
					content: $(_this.$refs.rcw_type_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_type != "") {
							_this.type_item = c_type_item;
							return;
						}
						_this.type_item = [];
					}
				}, function() {
					let texts = [];
					_this.type_arr.forEach(function(item) {
						_this.type_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_type = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_type != "") {
						_this.type_item = c_type_item;
						return;
					}
					_this.type_item = [];
				});
			},
			// 全选
			typeAllCheck: function() {
				let _this = this;
				_this.type_all = _this.c_type_all;
				if(!_this.type_all) { // 实现全选
					_this.type_item = [];
					_this.type_arr.forEach(function(item) {
						_this.type_item.push(item.id);
					});
				} else { // 实现反选
					_this.type_item = [];
				}
			},
			// 审批人
			openEditAdmin: function(e) {
				let _this = this;
				let c_admin_item = _this.admin_item;

				layer.confirm('', {
					skin: 'public-alert-skin',
					type: 1,
					btn: ['确定', '取消'], // 按钮
					title: ['审批人', true],
					area: ['660px', ''], // 宽高
					content: $(_this.$refs.rcw_admin_alert),
					cancel: function() {
						// 右上角关闭
						if(_this.edit_admin != "") {
							_this.admin_item = c_admin_item;
							return;
						}
						_this.admin_item = [];
					}
				}, function() {
					let texts = [];
					_this.admin_arr.forEach(function(item) {
						_this.admin_item.forEach(function(item2) {
							if(item.id == item2) {
								texts.push(item.name);
							}
						});
					});
					_this.edit_admin = texts.join(",");
					layer.closeAll();
				}, function() {
					if(_this.edit_admin != "") {
						_this.admin_item = c_admin_item;
						return;
					}
					_this.admin_item = [];
				});
			},
			// 全选
			adminAllCheck: function() {
				let _this = this;
				_this.admin_all = _this.c_admin_all;
				if(!_this.admin_all) { // 实现全选
					_this.admin_item = [];
					_this.admin_arr.forEach(function(item) {
						_this.admin_item.push(item.id);
					});
				} else { // 实现反选
					_this.admin_item = [];
				}
			},
			// 返回列表
			backList() {
				this.showList = true;
			},
			// 保存
			editSave() {
				let _this = this;
				
				let datas = {
					"header": Vue.request_header,
					"request": {
						"param": {
							"name": _this.edit_name,
							"shop_id": $(_this.$refs.edit_shop).val(),
							"room_area": _this.area_item,
							"room_type": _this.type_item,
							"use_every_day": _this.edit_usedate_everyday,
							"start_date": _this.edit_usedate_start,
							"end_date": _this.edit_usedate_end,
							"use_all_day": _this.edit_usetime_allday,
							"start_time": _this.edit_usetime_start,
							"end_time": _this.edit_usetime_end,
							"apply_admin_ids": _this.admin_item
						}
					},
					"comment": ""
				};
				if(_this.modify == '2') {
					datas.request.param.id = _this.edit_id;
				}
				datas = JSON.stringify(datas);
				$.ajax({
					type: "POST",
					dataType: "json",
					url: Vue.ctUrl + "Setting/editGuestLeaveStoreApplyRule",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: datas,
					success: function(data) {
						if(data['response']['result_code'] == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.rcw_list).bootstrapTable('refresh');
							_this.showList = true;
						} else {
							Vue.timeoutfun(data.response.result_status,_this);
							layer.msg(data["response"]["error_msg"]);
						}
					},
					error: function(err) {
						layer.msg('出错啦');
					}
				});
			},
			// 删除
			delRcw: function(id, shop_id) {
				let _this = this;

				let datas = {
					"header": Vue.request_header,
					"request": {
						"version": Vue.version,
						"param": {
							"id": id,
							"shop_id": shop_id
						}
					},
					"comment": ""
				};
				let datas2 = JSON.stringify(datas);
				$.ajax({
					type: "post",
					dataType: "json",
					url: Vue.ctUrl + "Setting/delGuestLeaveStoreApplyRule",
					crossDomain: true,
					xhrFields: {
						withCredentials: true
					},
					data: {
						json: datas2
					},
					success: function(data) {
						if(data.response.result_code == "true") {
							layer.msg(data.response.error_msg);
							$(_this.$refs.rcw_list).bootstrapTable("refresh");
						} else {
							Vue.timeoutfun(data.response.result_status, _this);
							layer.msg(data.response.error_msg);
						}
					},
					error: function(err) {
						layer.msg("出错啦");
					}
				});
			},
		}

	}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
	.guest-leave-store-apply-wrap {
		.rcw-edit {
			.edit-usedate {
				position: relative;
				.edit-usedate-everyday {
					label {
						margin: 0 0 10px 9px;
						font-weight: normal;
					}
				}
			}
		}
	}
</style>